import { render, staticRenderFns } from "./TextDedup.vue?vue&type=template&id=1ac5bc44&scoped=true"
import script from "./TextDedup.vue?vue&type=script&lang=js"
export * from "./TextDedup.vue?vue&type=script&lang=js"
import style0 from "./TextDedup.vue?vue&type=style&index=0&id=1ac5bc44&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ac5bc44",
  null
  
)

export default component.exports